import React from "react";
import { Icon } from "@iconify/react";
import { useTheme } from "../../../contexts/ThemeContext";

interface PillProps {
  icon?: string;
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
}

export const Pill: React.FC<PillProps> = ({
  icon,
  label,
  isSelected,
  onClick,
  className = "",
}) => {
  const { theme } = useTheme();

  return (
    <button
      onClick={onClick}
      className={`
        px-4 py-1.5
        rounded-full
        text-sm font-medium
        border
        transition-all duration-200
        whitespace-nowrap
        ${
          isSelected
            ? theme.mode === "dark"
              ? "bg-primary-500 text-text-primary border-primary-500 hover:bg-primary-600 hover:border-primary-600"
              : "bg-primary-500 text-background-primary border-primary-500"
            : theme.mode === "dark"
            ? "bg-primary-900/30 text-primary-300 border-primary-700 hover:bg-primary-500 hover:text-white hover:border-primary-500"
            : "bg-white/10 text-text-inverse border-text-inverse/30 hover:bg-primary-500 hover:text-white hover:border-primary-500"
        }
        ${className}
      `}
    >
      <div className="flex items-center gap-2">
        {icon && (
          <Icon
            icon={icon}
            className={`w-4 h-4`}
          />
        )}
        <span
          className={`
            font-light
            `}
        >
          {label}
        </span>
      </div>
    </button>
  );
};

export default Pill;
